import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';

import { GridService } from '@core/services';

@Component({
  selector: 'z-legend',
  templateUrl: './legend.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegendComponent implements OnDestroy {
  destroy$ = new Subject<void>();

  @Input() type: string = 'grid';
  @Input() showHeader: boolean = true;
  @Input() showHeaderInline: boolean = false;
  @Input() headerTextKey: string = 'core.components.grid.legend.heading';

  @Input() style: any = null;

  constructor(public gridService: GridService) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
